// extracted by mini-css-extract-plugin
export var card = "_ll-0";
export var content = "_ll-2";
export var details = "_ll-3";
export var icon = "_ll-1";
export var iconBlue = "_ll-5";
export var iconBrand = "_ll-4";
export var iconGrayBlue = "_ll-6";
export var iconGreen = "_ll-7";
export var iconIndigo = "_ll-8";
export var iconOrange = "_ll-9";
export var iconPurple = "_ll-a";
export var iconRed = "_ll-b";
export var iconWarning = "_ll-c";